import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import dropdown from "../../../assets/common/dropdown.svg";
import errorInfo from "../../../assets/common/errorInfo.svg";
import shield from "../../../assets/common/shield.svg";
import clear from "../../../assets/common/clear.svg";
import upload from "../../../assets/common/upload.svg";
import trash from "../../../assets/common/trash.svg";

import { toast } from "react-toastify";
import {
  Button,
  GenericDiv,
  RespFont,
  FlexRowBetween,
  DropOption,
  PlaceHolderImage,
  PopupForm,
  Input,
  Label,
} from "../../common/Style";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { addMany } from "../../../store/reducers/guestsReducer";
import { CFV, addAlpha } from "../../common/others/Functions";
import OWC from "./OWC";

let inputs = {};
let inputsErrors = {};
let multyChoise = {};

const AddList = (props) => {
  const { user } = useSelector((state) => state.authReducer);
  const defaultPreSms1 = `${user.brideFN + " " + user.brideLN} ו${
    user.groomFN + " " + user.groomLN
  } שמחים להזמינכם לחתונתם!`;
  const [doneB, setDoneB] = useState(true);
  const [isMultyChoiseChanged, setIsMultyChoiseChanged] = useState(false);
  const [arrC, setArrC] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [inviting, setInviting] = useState("");
  const [listInput, setListInput] = useState("");

  const [dis, setDis] = useState(true);
  const [contacts, setContacts] = useState([]);

  const add_del = (item) => {
    if (multyChoise[item._id] !== undefined) {
      delete multyChoise[item._id];
    } else multyChoise[item._id] = { tel: item.tel, name: item.name };
    setIsMultyChoiseChanged(!isMultyChoiseChanged);
  };

  let listArray = useMemo(() => {
    let ii = [];
    let checked, disabled;
    if (arrC !== null)
      for (let i = 0; i < arrC.length; i++) {
        checked =
          multyChoise[arrC[i]._id] !== undefined ||
          props.phones[arrC[i].tel] !== undefined;
        disabled = props.phones[arrC[i].tel] !== undefined;
        if (
          arrC[i].name !== undefined &&
          (searchText.length === 0 ||
            arrC[i].name?.toLowerCase().includes(searchText.toLowerCase()))
        )
          ii.push(
            <RespFont
              key={i}
              onClick={() => {
                add_del({
                  _id: arrC[i]._id,
                  name: arrC[i].name,
                  tel: arrC[i].tel,
                });
              }}
              style={{
                width: "max-content",
                padding: "5px 8px",
                margin: "5px",
                cursor: "pointer",
                borderRadius: "2px",
                transition: "200ms",
                background: disabled
                  ? addAlpha("#7b96c4", 0.2)
                  : checked
                  ? addAlpha("#7b96c4", 0.5)
                  : "inherit",
              }}
            >
              {arrC[i].name}
            </RespFont>
          );
      }
    return ii;
  }, [searchText, arrC, isMultyChoiseChanged]);

  // parse list input
  const parseListInput = (inputText) => {
    const lines = inputText.split("\n").filter((line) => line.trim() !== "");
    const cc = [];

    for (let i = 0; i < lines.length; i++) {
      const currentLine = lines[i]?.trim();

      if (!currentLine) continue;

      // בדיקה אם השורה הבאה היא מספר טלפון
      const nextLine = lines[i + 1]?.trim();
      if (nextLine) {
        // ניקוי מספר הטלפון לבדיקה
        let cleanTel = nextLine.replaceAll(/[^\d]/g, "");
        if (cleanTel[0] === "9" && cleanTel[1] === "7" && cleanTel[2] === "2") {
          cleanTel = cleanTel.substring(3);
        }
        if (cleanTel[0] === "0") {
          cleanTel = cleanTel.substring(1);
        }

        // בדיקה אם זה נראה כמו מספר טלפון ישראלי (9 ספרות שמתחיל ב-5)
        if (cleanTel.length === 9 && cleanTel[0] === "5") {
          // זה שם עם טלפון - נוסיף לרשימה
          cc.push({
            _id: i,
            name: currentLine,
            tel: cleanTel,
          });

          // דלג על השורה הבאה (הטלפון) כי כבר עיבדנו אותה
          i++;
        }
        // אם זה לא נראה כמו טלפון, נדלג על השורה הנוכחית (זה תיאור)
      }
      // אם אין שורה הבאה, נדלג על השורה הנוכחית
    }

    return cc;
  };

  const handleListProcess = () => {
    if (!listInput.trim()) {
      toast.warning("אנא הכנס רשימת אנשי קשר");
      return;
    }

    const vcfData = parseListInput(listInput);
    if (vcfData.length === 0) {
      toast.warning("לא נמצאו אנשי קשר בפורמט הנכון");
      return;
    }

    const cc = [];
    const sortedArray = [...vcfData];
    sortedArray.sort(function (a, b) {
      var x = a["name"];
      var y = b["name"];

      if (typeof x == "string") {
        x = ("" + x).toLowerCase();
      }
      if (typeof y == "string") {
        y = ("" + y).toLowerCase();
      }

      return x < y ? -1 : x > y ? 1 : 0;
    });

    for (let i = 0; i < sortedArray.length; i++) {
      cc.push({
        _id: i,
        name: sortedArray[i]["name"],
        tel: sortedArray[i]["tel"],
      });
    }

    setArrC(cc);

    // בחירה אוטומטית של כל אנשי הקשר שנמצאו
    multyChoise = {};
    cc.forEach((contact) => {
      // בדיקה אם הטלפון כבר קיים ברשימת האורחים
      if (props.phones[contact.tel] === undefined) {
        multyChoise[contact._id] = { tel: contact.tel, name: contact.name };
      }
    });

    setIsMultyChoiseChanged(!isMultyChoiseChanged);
    toast.success(`נמצאו ${cc.length} אנשי קשר - כולם נבחרו אוטומטית`);
  };

  let height = window.screen.availHeight;
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [closeness, setCloseness] = useState("");
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(true);
  const [owc, setOwc] = useState("קשר");
  const [showDropOwc, setShowDropOwc] = useState(false);
  const width = window.screen.availWidth;
  const [animate, setAnimate] = useState(
    "animate__animated animate__heartBeat animate__infinite"
  );

  const handleOnSelect = (item) => {
    setCloseness(item.id);
  };

  const handleOnSearch = (string, results) => {
    setCloseness(string);
  };

  const digitOrNull = (value) =>
    parseInt(value) >= 0 ? parseInt(value) : null;

  const onSubmit = async (data) => {
    setChecked(false);
    let rows = [
      ["שם מלא", "טלפון", "קירבה", "מוזמנים", "אישרו", "מזמין", "קשר", "מספר"],
    ];
    let newOwc = "";
    if (
      user.eventType &&
      ((inviting?.length && owc === "קשר") ||
        (inviting?.length === 0 && owc !== "קשר"))
    )
      toast.warning("שדה המזמין והקשר באים ביחד - הכל או כלום");
    else if (closeness.length > 1) {
      newOwc = owc;
      for (let i = 0; i < contacts.length; i++) {
        if (inputs[i] !== false)
          rows.push([
            data[`${i}name`],
            data[`${i}phone`].length ? data[`${i}phone`] : null,
            closeness,
            digitOrNull(data[`${i}sum`]),
            digitOrNull(data[`${i}accept`]),
            inviting,
            newOwc === "קשר" ? "" : newOwc,
            i + 1,
          ]);
      }
      if (rows.length === 1) toast.warning("לא נבחרו רשומות להוספה");
      else {
        dispatch(addMany({ rows })).then((res) => {
          setChecked(true);
          if (!res.payload?.error) {
            toast.success("הפעולה בוצעה בהצלחה!!");
            setTimeout(function () {
              setLoading(false);
              multyChoise = {};
              inputs = {};
              setContacts([]);
              props.init();
            }, 2000);
          } else {
            multyChoise = {};
            setLoading(false);
            toast.error("לא כל הרשומות נטענו בהצלחה, ראו פירוט בכל שורה");

            for (let i = 0; i < contacts.length; i++) inputs[i] = false;
            for (let i = 0; i < res.payload?.error.length; i++) {
              inputs[res.payload?.error[i]["מספר"] - 1] = true;
              inputsErrors[res.payload?.error[i]["מספר"] - 1] =
                res.payload?.error[i]["סיבה"];
            }

            setFlag(!flag);
          }
        });
      }
    } else toast.warning("שדה קירבה לא יכול להיות פחות מ 2 תווים");
  };

  const handleSwitch = (e, i) => {
    inputs[i] = e;
    setFlag(!flag);
  };

  let guestsArray = useMemo(() => {
    let guests = [];
    for (let i = 0; i < contacts.length; i++) {
      guests.push(
        <div
          key={i}
          style={{
            display: checked && inputs[i] === false ? "none" : "flex",
            flexDirection: "column",
            width: "94%",
            margin: "0 auto",
            padding: "10px 15px",
            backgroundColor: addAlpha("#7b96c4", 0.15),
            marginTop: "10px",
            borderRadius: "5px",
            paddingTop: "0px",
          }}
        >
          <FlexRowBetween style={{ marginTop: "10px" }}>
            <div style={{ position: "relative", width: "50%" }}>
              <Input
                style={{ padding: "5px 0", paddingRight: "2px" }}
                placeholder={"שם מלא"}
                type="text"
                defaultValue={contacts[i]["name"]}
                {...register(`${i}name`, {
                  required: true,
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV(`${i}name`, "בין 2 ל 50 תווים", errors)}
            </div>
            <div style={{ position: "relative", width: "40%" }}>
              <Input
                style={{ padding: "5px 0", paddingRight: "2px" }}
                placeholder={"מס׳ נייד"}
                type="text"
                defaultValue={contacts[i]["tel"]}
                {...register(`${i}phone`, {
                  pattern: /^[0]{0,1}[5]{1}[0-9]{8}$/,
                })}
              />
              {CFV(`${i}phone`, "פורמט מספר פלאפון לא חוקי", errors)}
            </div>
          </FlexRowBetween>
          <FlexRowBetween style={{ alignItems: "flex-end", marginTop: "10px" }}>
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{ padding: "5px 0", paddingRight: "2px" }}
                placeholder={"כמות"}
                defaultValue={1}
                type="number"
                {...register(`${i}sum`, {
                  required: true,
                  min: 1,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}sum`, `מספר בין 1 ל ${props.acceptLimit}`, errors)}
            </div>
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{ padding: "5px 0", paddingRight: "2px" }}
                placeholder={"אישרו"}
                type="number"
                {...register(`${i}accept`, {
                  min: 0,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}accept`, `מספר בין 0 ל ${props.acceptLimit}`, errors)}
            </div>

            {checked && inputs[i] && (
              <OverlayTrigger
                placement={"bottom"}
                overlay={
                  <Tooltip>
                    {inputsErrors[i] !== undefined && inputsErrors[i] !== ""
                      ? inputsErrors[i]
                      : "רשומה זו נכנסה בהצלחה!"}
                  </Tooltip>
                }
              >
                <img
                  src={
                    inputsErrors[i] !== undefined && inputsErrors[i] !== ""
                      ? errorInfo
                      : shield
                  }
                  style={{ width: "30px" }}
                  className={animate}
                />
              </OverlayTrigger>
            )}
          </FlexRowBetween>
        </div>
      );
    }

    return [guests];
  }, [flag, contacts.length, contacts, errors]);

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      style={{ height: "min-content", maxHeight: `${height * 0.8}px` }}
    >
      <FlexRowBetween
        style={{
          width: "90%",
          margin: "10px auto",
          marginTop: "30px",
          alignItems: "flex-end",
        }}
      >
        <div
          className="relativeBox"
          style={{
            zIndex: "1",
            marginRight: "0",
            width: "65%",
          }}
        >
          <Label>קירבה</Label>
          <ReactSearchAutocomplete
            items={props.categories}
            onSelect={handleOnSelect}
            autoFocus
            onSearch={handleOnSearch}
            fuseOptions={{ minMatchCharLength: 1 }}
            maxResults={show ? 10 : 0}
            showNoResults={false}
            styling={{
              searchIconMargin: "0 5px 0 10px",
              clearIconMargin: "4px 0 0 5px",
              borderRadius: "5px",
              width: "100%",
              height: "40px",
              fontFamily: "heb",
            }}
          />
        </div>
        <OverlayTrigger
          placement={"bottom"}
          overlay={
            <Tooltip>
              {show ? "הסתרת השלמות לחיפוש" : "הצגת השלמות לחיפוש"}
            </Tooltip>
          }
        >
          <GenericDiv
            style={{ marginLeft: "0", padding: "10px 15px" }}
            background={"#7b96c4"}
            onClick={() => setShow(!show)}
          >
            {show ? "הסתר" : "הצג"}
          </GenericDiv>
        </OverlayTrigger>
      </FlexRowBetween>

      {user.eventType && (
        <FlexRowBetween
          style={{
            width: "90%",
            margin: "10px auto",
            alignItems: "flex-end",
          }}
        >
          <div style={{ position: "relative", width: "65%" }}>
            <div>
              <Label>המזמין</Label>
              <RespFont
                psize={"12px"}
                csize={"14px"}
                style={{ textAlign: "right" }}
              >
                (במידה ואלו מוזמנים של הזוג יש לדלג על שורה זו)
              </RespFont>
            </div>
            <Input onChange={(e) => setInviting(e.target.value)} type="text" />
          </div>
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
          >
            <GenericDiv
              background={"#7b96c4"}
              style={{
                position: "relative",
                height: "30px",
                padding: "19.5px 10px",
                marginLeft: "0px",
                marginTop: "7px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropOwc(!showDropOwc);
              }}
            >
              <div>{owc}</div>
              <img
                src={dropdown}
                alt={"dropdown"}
                style={{ width: "25px", marginLeft: "-7px" }}
              />
              {showDropOwc && (
                <OWC setOwc={setOwc} setShowDropOwc={setShowDropOwc} />
              )}
            </GenericDiv>
          </OverlayTrigger>
        </FlexRowBetween>
      )}
      {user.eventType && (
        <FlexRowBetween
          style={{ width: "90%", margin: "0 auto", marginBottom: "20px" }}
        >
          <RespFont>
            {inviting !== "" && owc !== "קשר" ? (
              inviting +
              (owc[owc.length - 1] === "ם"
                ? " שמחים"
                : owc[owc.length - 1] === "ו"
                ? " שמח"
                : " שמחה") +
              " להזמינכם לחתונת " +
              owc +
              (owc.includes("ת") ? ` ${user.brideFN}.` : ` ${user.groomFN}.`)
            ) : (
              <>ברירת מחדל: {defaultPreSms1}</>
            )}
          </RespFont>
        </FlexRowBetween>
      )}

      {guestsArray[0]}
      <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
        {contacts.length ? (
          <Button
            style={{
              margin: "0 auto",
              width: "50%",
              background: user && "#7b96c4",
            }}
            type="submit"
          >
            אישור
          </Button>
        ) : null}
      </FlexRowBetween>
      <div style={{ height: "10px" }}></div>
      {loading && <OpacityLoading />}
      {doneB && (
        <FlexRowBetween
          style={{
            justifyContent: "space-between",
            width: "90%",
            margin: "0 auto",
            marginTop: "-0px",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "110px",
              marginTop: "-10px",
            }}
          >
            <PlaceHolderImage
              onClick={() => setSearchText("")}
              fontSize={`27px`}
              top={`46.5px`}
              src={clear}
              alt="clear"
              style={{
                cursor: "pointer",
                border: "1px solid silver",
                padding: "4px",
                left: `5.5px`,
                borderRadius: "2px",
              }}
            />
            <Label>חיפוש</Label>
            <Input
              value={searchText}
              type="text"
              required={true}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div style={{ direction: "ltr", width: "200px" }}>
            <textarea
              value={listInput}
              onChange={(e) => setListInput(e.target.value)}
              placeholder="הדבק כאן רשימת אנשי קשר:
המערכת תזהה אוטומטית שמות וטלפונים.
תיאורים נוספים יועלמו אוטומטית.

דוגמה:
יוסי כהן
0501234567
תיאור על יוסי...
דני לוי
0529876543"
              style={{
                width: "100%",
                height: "180px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontFamily: "heb",
                direction: "rtl",
                resize: "vertical",
              }}
            />
          </div>
          <GenericDiv
            background={"#7b96c4"}
            style={{
              width: "min-content",
              padding: "9px 10px",
            }}
            onClick={() => {
              handleListProcess();
            }}
          >
            עיבוד רשימה
          </GenericDiv>
          <GenericDiv
            background={"#7b96c4"}
            style={{
              width: "min-content",
              padding: "9px 10px",
            }}
            onClick={() => {
              setContacts(Object.values(multyChoise));
              setDoneB(false);
            }}
          >
            סיום
          </GenericDiv>
        </FlexRowBetween>
      )}
      {doneB && (
        <FlexRowBetween
          style={{
            flexWrap: "wrap",
            width: "90%",
            margin: "10px auto",
            height: "300px",
            overflow: "auto",
          }}
        >
          {listArray}
        </FlexRowBetween>
      )}
    </PopupForm>
  );
};

export default AddList;
